import Icon from 'veui/components/Icon'

Icon.register({
  location: {
    paths: [
      {
        d: 'M384 736a31.92 31.92 0 01-19.2-6.4l-20.2-15.15a816.55 816.55 0 01-190-200.82A347.93 347.93 0 0196 320a288 288 0 11576 0 348 348 0 01-58.62 193.63 816.78 816.78 0 01-190 200.82L403.2 729.6A32 32 0 01384 736zm0-640a224 224 0 00-224 224 284.22 284.22 0 0047.88 158.13A752.68 752.68 0 00383 663.25l1 .75 1-.75a752.68 752.68 0 00175.12-185.12A284.2 284.2 0 00608 320 224 224 0 00384 96zm0 352a128 128 0 11128-128 128.14 128.14 0 01-128 128zm0-192a64 64 0 1064 64 64.07 64.07 0 00-64-64z'
      }
    ],
    width: '768',
    height: '768'
  }
})
